import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import HintIcon from '@material-ui/icons/Info';
import LinkIcon from '@material-ui/icons/LinkRounded';
import WarningIcon from '@material-ui/icons/Error';
import { Tooltip, IconButton, TextField, FormControl, InputLabel, FormHelperText, MenuItem, Select, OutlinedInput, FilledInput, FormControlLabel, Checkbox, Switch, Button, Typography, Grid, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useField, useFormikContext, FieldArray, Formik, Form } from 'formik';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import { Autocomplete } from '@material-ui/lab';
import Editor from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'yup';
import MomentUtils from '@date-io/moment';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".index_flexGrow__2uAAj{\nflex-grow: 1;\n}\n\n.index_flex__3SFQ8{\ndisplay: flex;\n}\n\n.index_buttonHint__1uUTu  {\nmargin-top: 5px;\nmargin : 5px 4px 0px 4px;\n}\n\n.index_errorBorderContainer__2Sqga{\n  border: 1px solid #F44336;\n  padding: 10px 15px 10px 15px;\n  border-radius: 4px;\n  margin:  7px 0px 4px 0px;\n}\n\n.index_errorColor__3Dlh5{\n  color:  #F44336!important;\n}\n\n.index_noCollapse__1zfH6 {\n  padding: 0.05px;\n}\n\n.index_borderContainer__3RfEg{\n    border: 1px solid rgba(0,0,0,0.25);\n    padding: 10px 15px 10px 15px;\n    border-radius: 4px;\n    margin:  7px 0px 4px 0px;\n  }\n\n  .index_marginContainer__1Z19u{\n    margin:  7px 0px 4px 0px;\n  }\n\n  .index_warningColor__1BiKS {\n    color: #ce8128;\n  }\n\n  .index_shadowContainer__29v8T {\n    margin : 6px;\n    padding: 10px;\n    border-radius: 5px;\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  .index_toolbarRTE__3dvud {\n    padding:  0px !important;\n    border: none;\n  }\n\n\n  .index_editorRTEReadOnly__1JXBi {\n    background-color:#EEEEEE!important;\n  }\n\n  .index_editorRTEError__qPBL0 {\n    border: 1px solid #F44336;\n  }\n\n /* .ql-container {\n    min-height: 10em;\n    border-bottom-left-radius: 0.5em;\n    border-bottom-right-radius: 0.5em;\n    background: #fefcfc;\n  }\n\n  .ql-toolbar {\n    background: #eaecec;\n    border-top-left-radius: 0.5em;\n    border-top-right-radius: 0.5em;\n    border-bottom: none;\n  } */\n\n";
var classes = { "flexGrow": "index_flexGrow__2uAAj", "flex": "index_flex__3SFQ8", "buttonHint": "index_buttonHint__1uUTu", "errorBorderContainer": "index_errorBorderContainer__2Sqga", "errorColor": "index_errorColor__3Dlh5", "noCollapse": "index_noCollapse__1zfH6", "borderContainer": "index_borderContainer__3RfEg", "marginContainer": "index_marginContainer__1Z19u", "warningColor": "index_warningColor__1BiKS", "shadowContainer": "index_shadowContainer__29v8T", "toolbarRTE": "index_toolbarRTE__3dvud", "editorRTEReadOnly": "index_editorRTEReadOnly__1JXBi", "editorRTEError": "index_editorRTEError__qPBL0" };
styleInject(css);

function HintWarning(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? "" : _ref$text,
      _ref$isWarning = _ref.isWarning,
      isWarning = _ref$isWarning === undefined ? false : _ref$isWarning,
      _ref$isLink = _ref.isLink,
      isLink = _ref$isLink === undefined ? false : _ref$isLink,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className;


  var upperHint = typeof text === "string" && text.toUpperCase();

  if (upperHint) {
    return React.createElement(
      'span',
      { className: classes.buttonHint + " " + className },
      React.createElement(
        Tooltip,
        { title: isLink ? "Go to" : upperHint },
        React.createElement(
          IconButton,
          {
            href: isLink ? text : null,
            target: isLink ? "_blank" : null,
            'aria-label': upperHint
          },
          isWarning ? React.createElement(WarningIcon, { className: classes.warningColor }) : isLink ? React.createElement(LinkIcon, { color: "primary" }) : React.createElement(HintIcon, { color: "primary" })
        )
      )
    );
  } else {
    return null;
  }
}
HintWarning.propTypes = {
  text: PropTypes.string,
  isWarning: PropTypes.bool,
  isLink: PropTypes.bool,
  className: PropTypes.string
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function TextFieldFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$multil = _ref$fieldData.multiline,
      multiline = _ref$fieldData$multil === undefined ? false : _ref$fieldData$multil,
      _ref$fieldData$isLink = _ref$fieldData.isLink,
      isLink = _ref$fieldData$isLink === undefined ? false : _ref$fieldData$isLink;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 2),
      field = _useField2[0],
      error = _useField2[1].error;

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(TextField, {
      name: path,
      value: field.value || '',
      onChange: field.onChange,
      onBlur: field.onBlur,
      error: !!error,
      helperText: error,
      required: required,
      className: classes.flexGrow,
      margin: "dense",
      multiline: multiline,
      variant: readOnly ? "filled" : "outlined",
      label: title,
      InputLabelProps: !title ? { shrink: false } : {},
      InputProps: {
        readOnly: readOnly
      }
    }),
    isLink && React.createElement(HintWarning, { text: field.value || '', isLink: true }),
    React.createElement(HintWarning, { text: hint })
  );
}
TextFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    multiline: PropTypes.bool,
    isLink: PropTypes.bool
  })
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$1 = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var lodash_get = get$1;

function DisplayValueFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$isLink = _ref$fieldData.isLink,
      isLink = _ref$fieldData$isLink === undefined ? false : _ref$fieldData$isLink,
      _ref$fieldData$yup = _ref$fieldData.yup,
      yup = _ref$fieldData$yup === undefined ? null : _ref$fieldData$yup,
      _ref$fieldData$multil = _ref$fieldData.multiline,
      multiline = _ref$fieldData$multil === undefined ? false : _ref$fieldData$multil,
      _ref$fieldData$transf = _ref$fieldData.transformation,
      transformation = _ref$fieldData$transf === undefined ? function (v) {
    return v;
  } : _ref$fieldData$transf,
      _ref$fieldData$displa = _ref$fieldData.display,
      display = _ref$fieldData$displa === undefined ? [] : _ref$fieldData$displa,
      _ref$fieldData$separa = _ref$fieldData.separator,
      separator = _ref$fieldData$separa === undefined ? "" : _ref$fieldData$separa;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  var displayedValue = display.map(function (displayItem) {
    if (displayItem && (!!displayItem.path || displayItem.path === "")) {
      var newValue = displayItem.path === "" ? values : lodash_get(values, displayItem.path);
      if (displayItem.transformation) {
        newValue = displayItem.transformation(newValue);
      }
      return newValue;
    } else if (displayItem || displayItem === 0) {
      return displayItem;
    } else {
      return "";
    }
  }).join(separator);

  if (transformation) {
    displayedValue = transformation(displayedValue);
  }

  var error = void 0;
  if (yup) {
    try {
      yup.validateSync(displayedValue);
    } catch (e) {
      error = e.message;
    }
  }

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(TextField, {
      className: classes.flexGrow,
      margin: "dense",
      required: required,
      variant: "filled",
      label: title,
      inputlabelprops: { shrink: true },
      InputProps: {
        readOnly: true
      },
      error: !!error,
      helperText: error,
      multiline: multiline,
      value: displayedValue
    }),
    isLink && React.createElement(HintWarning, { text: displayedValue || '', isLink: true }),
    React.createElement(HintWarning, { text: hint })
  );
}
DisplayValueFormik.propTypes = {
  fieldData: PropTypes.shape({
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    multiline: PropTypes.bool,
    yup: PropTypes.object,
    transformation: PropTypes.func,
    separator: PropTypes.string,
    display: PropTypes.array,
    isLink: PropTypes.bool
  })
};

function SelectFieldFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$choice = _ref$fieldData.choices,
      choices = _ref$fieldData$choice === undefined ? [] : _ref$fieldData$choice;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 2),
      field = _useField2[0],
      error = _useField2[1].error;

  var selectRef = useRef(null);

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      labelWidth = _useState2[0],
      setLabelWidth = _useState2[1];

  var noLabelNotchWidth = title ? title.length * 9 : 0;

  useEffect(function () {
    if (selectRef && selectRef.current) {
      var _labelWidth = selectRef.current.offsetWidth;
      setLabelWidth(_labelWidth);
    }
  }, [title]);

  var menu = choices.map(function (choice, i) {
    if (!choice && choice !== 0) {
      return React.createElement(
        MenuItem,
        { key: i, value: null },
        "-"
      );
    } else if ((typeof choice === "undefined" ? "undefined" : _typeof(choice)) === "object") {
      return React.createElement(
        MenuItem,
        { key: i, value: choice.value, disabled: choice.readOnly },
        choice.title || choice.value
      );
    } else {
      return React.createElement(
        MenuItem,
        { key: i, value: choice },
        choice
      );
    }
  });

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(
      FormControl,
      {
        error: !!error,
        variant: readOnly ? "filled" : "outlined",
        margin: "dense",
        className: classes.flexGrow },
      React.createElement(
        InputLabel,
        {
          shrink: !!field.value || field.value === 0,
          required: required,
          ref: selectRef,
          htmlFor: path },
        title
      ),
      React.createElement(
        Select,
        {
          name: field.name,
          value: field.value === 0 ? 0 : field.value || '',
          onChange: field.onChange,
          input: readOnly ? React.createElement(FilledInput, {
            readOnly: true
          }) : React.createElement(OutlinedInput, {
            labelWidth: labelWidth || noLabelNotchWidth,
            notched: !!field.value || field.value === 0
          }),
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 300
              }
            }
          },
          label: title
        },
        menu
      ),
      error && React.createElement(
        FormHelperText,
        { margin: "dense", error: true },
        error
      )
    ),
    React.createElement(HintWarning, { text: hint })
  );
}
SelectFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    choices: PropTypes.array
    // choices: PropTypes.oneOfType([
    //   PropTypes.arrayOf(PropTypes.object),
    //   PropTypes.arrayOf(PropTypes.oneOfType([
    //     PropTypes.string.isRequired,
    //     PropTypes.number.isRequired,
    //   ])),
    // ]),
  })
};

function DateTimeFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$openTo = _ref$fieldData.openTo,
      openTo = _ref$fieldData$openTo === undefined ? "date" : _ref$fieldData$openTo,
      _ref$fieldData$simple = _ref$fieldData.simple,
      simple = _ref$fieldData$simple === undefined ? false : _ref$fieldData$simple;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 3),
      field = _useField2[0],
      error = _useField2[1].error,
      helpers = _useField2[2];

  var DateComponent = readOnly ? DatePicker : KeyboardDatePicker;

  return React.createElement(
    'div',
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(DateComponent, {
      margin: "dense",
      name: field.name,
      disableToolbar: simple,
      variant: simple ? "inline" : null,
      openTo: openTo,
      required: required,
      error: !!error,
      helperText: error,
      className: classes.flexGrow
      // clearable //solve warning
      , inputVariant: readOnly ? "filled" : "outlined",
      autoOk: true,
      label: title,
      format: 'MM/DD/YYYY',
      readOnly: readOnly,
      placeholder: '01/01/2020',
      onChange: function onChange(value) {
        helpers.setValue(value && value.toDate() || null);
      },
      value: field.value || null
    }),
    React.createElement(HintWarning, { text: hint })
  );
}
DateTimeFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    openTo: PropTypes.string
  })
};

function CheckboxFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      isSwitch = _ref.isSwitch;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 1),
      field = _useField2[0];

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(FormControlLabel, {
      control: isSwitch ? React.createElement(Switch, {
        checked: !!field.value, name: path, onChange: field.onChange
      }) : React.createElement(Checkbox, {
        checked: !!field.value, name: path, onChange: field.onChange
      }),
      disabled: readOnly,
      label: required ? title + " *" : title,
      required: required
    }),
    React.createElement(HintWarning, { text: hint })
  );
}
CheckboxFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string
  })
};

function ArrayFieldFormik(_ref) {
  var FieldGenerator = _ref.FieldGenerator,
      _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$emptyA = _ref$fieldData.emptyAddText,
      emptyAddText = _ref$fieldData$emptyA === undefined ? "Add" : _ref$fieldData$emptyA,
      _ref$fieldData$subfie = _ref$fieldData.subfield,
      subfield = _ref$fieldData$subfie === undefined ? {} : _ref$fieldData$subfie,
      _ref$fieldData$noBord = _ref$fieldData.noBorder,
      noBorder = _ref$fieldData$noBord === undefined ? false : _ref$fieldData$noBord,
      _ref$fieldData$withSw = _ref$fieldData.withSwap,
      withSwap = _ref$fieldData$withSw === undefined ? false : _ref$fieldData$withSw,
      _ref$fieldData$render = _ref$fieldData.renderRightButton,
      renderRightButton = _ref$fieldData$render === undefined ? null : _ref$fieldData$render;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 2),
      value = _useField2[0].value,
      error = _useField2[1].error;

  var haveError = !!error && !(Array.isArray(error) && error.every(function (v) {
    return !v;
  }));

  return React.createElement(FieldArray, {
    validateOnChange: false,
    name: path,
    render: function render(arrayHelpers) {
      return React.createElement(
        'div',
        { className: noBorder ? "" : haveError ? classes.errorBorderContainer : classes.borderContainer },
        title && React.createElement(
          Typography,
          { variant: 'body2', gutterBottom: true,
            color: 'textSecondary',
            component: 'div',
            className: haveError ? classes.errorColor : ""
          },
          required ? title + " *" : title,
          React.createElement(HintWarning, { text: warning, isWarning: true }),
          React.createElement(HintWarning, { text: hint })
        ),
        value && value.length > 0 ? React.createElement(
          'div',
          null,
          value.map(function (arrayValue, index) {
            return React.createElement(
              'div',
              { className: classes.flex, key: index },
              React.createElement(
                'span',
                { className: classes.flexGrow },
                React.createElement(FieldGenerator, {
                  fieldData: _extends({
                    path: path + "[" + index + "]"
                  }, subfield, {
                    value: arrayValue
                  }),
                  readOnly: readOnly })
              ),
              withSwap && value.length > 1 && React.createElement(
                'div',
                { className: classes.buttonHint },
                React.createElement(
                  Tooltip,
                  { title: "Swap down" },
                  React.createElement(
                    IconButton,
                    {
                      disabled: readOnly,
                      onClick: function onClick() {
                        return arrayHelpers.swap(index, value.length === index + 1 ? 0 : index + 1);
                      },
                      color: 'primary'
                    },
                    React.createElement(ArrowDropDownCircleIcon, null)
                  )
                )
              ),
              React.createElement(
                'div',
                { className: classes.buttonHint },
                React.createElement(
                  Tooltip,
                  { title: "Add" },
                  React.createElement(
                    IconButton,
                    {
                      disabled: readOnly,
                      onClick: function onClick() {
                        return arrayHelpers.insert(index + 1, '');
                      },
                      color: 'primary'
                    },
                    React.createElement(AddIcon, null)
                  )
                )
              ),
              React.createElement(
                'div',
                { className: classes.buttonHint },
                React.createElement(
                  Tooltip,
                  { title: "Remove" },
                  React.createElement(
                    IconButton,
                    {
                      disabled: readOnly,
                      onClick: function onClick() {
                        return arrayHelpers.remove(index);
                      },
                      color: 'primary'
                    },
                    React.createElement(RemoveIcon, null)
                  )
                )
              ),
              renderRightButton && React.createElement(
                'div',
                { className: classes.buttonHint },
                renderRightButton
              )
            );
          })
        ) : React.createElement(
          Button,
          { variant: 'outlined', disabled: readOnly, onClick: function onClick() {
              return arrayHelpers.push('');
            } },
          emptyAddText
        ),
        !!error && !Array.isArray(error) && React.createElement(
          FormHelperText,
          { error: true },
          error
        )
      );
    }
  });
}

ArrayFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    withSwap: PropTypes.bool,
    emptyAddText: PropTypes.string,
    noBorder: PropTypes.bool,
    subfield: PropTypes.object,
    renderRightButton: PropTypes.object
  })
};

function ArrayOfObjectFieldFormik(_ref) {
  var FieldGenerator = _ref.FieldGenerator,
      fieldData = _ref.fieldData,
      _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$emptyA = _ref$fieldData.emptyAddText,
      emptyAddText = _ref$fieldData$emptyA === undefined ? "Add" : _ref$fieldData$emptyA,
      _ref$fieldData$noBord = _ref$fieldData.noBorder,
      noBorder = _ref$fieldData$noBord === undefined ? false : _ref$fieldData$noBord;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 2),
      value = _useField2[0].value,
      error = _useField2[1].error;

  var haveError = !!error && !(Array.isArray(error) && error.every(function (v) {
    return !v;
  }));

  return React.createElement(FieldArray, {
    validateOnChange: false,
    name: path,
    render: function render(arrayHelpers) {
      return React.createElement(
        'div',
        { className: noBorder ? "" : haveError ? classes.errorBorderContainer : classes.borderContainer },
        title && React.createElement(
          Typography,
          { variant: 'body2', gutterBottom: true,
            className: haveError ? classes.errorColor : "",
            color: 'textSecondary',
            component: 'div' },
          required ? title + " *" : title,
          React.createElement(HintWarning, { text: warning, isWarning: true }),
          React.createElement(HintWarning, { text: hint })
        ),
        value && value.length > 0 ? React.createElement(
          'div',
          null,
          value.map(function (arrayValue, index) {
            return React.createElement(
              'span',
              { key: index },
              React.createElement(RenderFieldsContainer, { arrayHelpers: arrayHelpers, index: index, fieldData: fieldData, value: value, FieldGenerator: FieldGenerator })
            );
          })
        ) : React.createElement(
          Button,
          {
            disabled: readOnly, variant: 'outlined',
            onClick: function onClick() {
              return arrayHelpers.push({});
            } },
          emptyAddText
        ),
        !!error && !Array.isArray(error) && React.createElement(
          FormHelperText,
          { error: true },
          error
        )
      );
    }
  });
}

function RenderFieldsContainer(_ref2) {
  var FieldGenerator = _ref2.FieldGenerator,
      arrayHelpers = _ref2.arrayHelpers,
      index = _ref2.index,
      value = _ref2.value,
      _ref2$fieldData = _ref2.fieldData,
      _ref2$fieldData$path = _ref2$fieldData.path,
      path = _ref2$fieldData$path === undefined ? "" : _ref2$fieldData$path,
      _ref2$fieldData$withS = _ref2$fieldData.withSwap,
      withSwap = _ref2$fieldData$withS === undefined ? false : _ref2$fieldData$withS,
      _ref2$fieldData$subfi = _ref2$fieldData.subfields,
      subfields = _ref2$fieldData$subfi === undefined ? {} : _ref2$fieldData$subfi,
      _ref2$fieldData$readO = _ref2$fieldData.readOnly,
      readOnly = _ref2$fieldData$readO === undefined ? false : _ref2$fieldData$readO;


  var needShadow = subfields.reduce(function (acc, current) {
    return acc + (current.col || 6);
  }, 0) > 12;

  var newObject = subfields.reduce(function (obj, item) {
    obj[item.name] = "";
    return obj;
  }, {});

  var fields = subfields.map(function (subfieldData, i) {
    return React.createElement(
      Grid,
      { key: i, item: true,
        xs: 12,
        sm: subfieldData.col || 6
      },
      React.createElement(
        'div',
        { className: classes.flexGrow },
        React.createElement(FieldGenerator, {
          fieldData: _extends({}, subfieldData, {
            path: path + "[" + index + "]." + subfieldData.name,
            value: value[index][subfieldData.name]
          }),
          readOnly: readOnly
        })
      )
    );
  });

  return React.createElement(
    'div',
    { className: classes.flex + " " + (needShadow && classes.shadowContainer) },
    React.createElement(
      Grid,
      { container: true, spacing: 2 },
      fields
    ),
    withSwap && value.length > 1 && React.createElement(
      'div',
      { className: classes.buttonHint },
      React.createElement(
        Tooltip,
        { title: "Swap down" },
        React.createElement(
          IconButton,
          {
            disabled: readOnly,
            onClick: function onClick() {
              return arrayHelpers.swap(index, value.length === index + 1 ? 0 : index + 1);
            },
            color: 'primary'
          },
          React.createElement(ArrowDropDownCircleIcon, null)
        )
      )
    ),
    React.createElement(
      'div',
      { className: classes.buttonHint },
      React.createElement(
        Tooltip,
        { title: "Add" },
        React.createElement(
          IconButton,
          {
            disabled: readOnly,
            onClick: function onClick() {
              return arrayHelpers.insert(index + 1, newObject);
            },
            color: 'primary'
          },
          React.createElement(AddIcon, null)
        )
      )
    ),
    React.createElement(
      'div',
      { className: classes.buttonHint },
      React.createElement(
        Tooltip,
        { title: "Remove" },
        React.createElement(
          IconButton,
          {
            disabled: readOnly,
            onClick: function onClick() {
              return arrayHelpers.remove(index);
            },
            color: 'primary'
          },
          React.createElement(RemoveIcon, null)
        )
      )
    )
  );
}
ArrayOfObjectFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    emptyAddText: PropTypes.string,
    noBorder: PropTypes.bool,
    subfields: PropTypes.arrayOf(PropTypes.object),
    withSwap: PropTypes.bool
  })
};

var localValue = "";

function AutocompleteFieldFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$freeSo = _ref$fieldData.freeSolo,
      freeSolo = _ref$fieldData$freeSo === undefined ? false : _ref$fieldData$freeSo,
      _ref$fieldData$option = _ref$fieldData.options,
      options = _ref$fieldData$option === undefined ? [] : _ref$fieldData$option,
      _ref$fieldData$getOpt = _ref$fieldData.getOptionLabel,
      _getOptionLabel = _ref$fieldData$getOpt === undefined ? function (v) {
    return v;
  } : _ref$fieldData$getOpt,
      _ref$fieldData$placeh = _ref$fieldData.placeholder,
      placeholder = _ref$fieldData$placeh === undefined ? "Search..." : _ref$fieldData$placeh;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 3),
      value = _useField2[0].value,
      error = _useField2[1].error,
      setValue = _useField2[2].setValue;

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(Autocomplete
    // defaultValue={}
    // loading={loading}
    , { className: classes.flexGrow,
      disabled: readOnly,
      options: options || [],
      getOptionLabel: function getOptionLabel(option) {
        return _getOptionLabel(option) || "";
      },
      value: value || "",
      onChange: function onChange(_, val) {
        if (freeSolo) {
          localValue = val;
        }
        setValue(val);
      },
      onClose: function onClose() {
        freeSolo && setValue(localValue);
      },
      freeSolo: freeSolo,
      onInputChange: function onInputChange(_, val) {
        if (freeSolo) {
          localValue = val;
        }
      },
      renderInput: function renderInput(params) {
        return React.createElement(TextField, _extends({}, params, {
          margin: "dense",
          error: !!error,
          required: required,
          helperText: error,
          readOnly: readOnly,
          disabled: false,
          label: title,
          fullWidth: true,
          variant: readOnly ? "filled" : "outlined",
          placeholder: placeholder
        }));
      }
    }),
    React.createElement(HintWarning, { text: hint })
  );
}
AutocompleteFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    freeSolo: PropTypes.bool,
    options: PropTypes.array,
    getOptionLabel: PropTypes.func,
    placeholder: PropTypes.string
  })
};

function AsyncAutocomplete(_ref) {
  var setValue = _ref.setValue,
      error = _ref.error,
      value = _ref.value,
      _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$path = _ref$fieldData.path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir,
      _ref$fieldData$getAsy = _ref$fieldData.getAsyncOptions,
      getAsyncOptions = _ref$fieldData$getAsy === undefined ? function () {
    return [];
  } : _ref$fieldData$getAsy,
      _ref$fieldData$placeh = _ref$fieldData.placeholder,
      placeholder = _ref$fieldData$placeh === undefined ? "Search..." : _ref$fieldData$placeh,
      _ref$fieldData$freeSo = _ref$fieldData.freeSolo,
      freeSolo = _ref$fieldData$freeSo === undefined ? false : _ref$fieldData$freeSo,
      _ref$fieldData$getOpt = _ref$fieldData.getOptionLabel,
      _getOptionLabel = _ref$fieldData$getOpt === undefined ? function (v) {
    return v;
  } : _ref$fieldData$getOpt;

  var _React$useState = React.useState(false),
      _React$useState2 = slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = slicedToArray(_React$useState3, 2),
      options = _React$useState4[0],
      setOptions = _React$useState4[1];

  var _React$useState5 = React.useState(""),
      _React$useState6 = slicedToArray(_React$useState5, 2),
      inputText = _React$useState6[0],
      setInputText = _React$useState6[1];

  var loading = open && !options;

  useEffect(function () {
    var active = true;
    getAsyncOptions(inputText || "").then(function (r) {
      return !!active && setOptions(r);
    });
    return function () {
      active = false;
    };
  }, [inputText, getAsyncOptions]);

  React.useEffect(function () {
    if (!open) {
      setOptions(null);
    }
  }, [open]);

  return React.createElement(
    "div",
    { className: classes.flex },
    React.createElement(HintWarning, { text: warning, isWarning: true }),
    React.createElement(Autocomplete
    // getOptionSelected={fieldData.getOptionSelected}
    , { getOptionLabel: function getOptionLabel(option) {
        return _getOptionLabel(option) || "";
      },
      freeSolo: freeSolo,
      options: options || [],
      loading: loading,
      open: open,
      onOpen: function onOpen() {
        setOpen(true);
      },
      onClose: function onClose() {
        setOpen(false);
      },
      onChange: function onChange(_, val) {
        setValue(val);
      },
      onInputChange: function onInputChange(_, val) {
        setInputText(val);
        setOptions(null);
        freeSolo && setValue(val);
      },
      filterOptions: function filterOptions(options, _ref2) {
        var inputValue = _ref2.inputValue;
        return options;
      },
      value: value || "",
      className: classes.flexGrow,
      disabled: readOnly,
      renderInput: function renderInput(params) {
        return React.createElement(TextField, _extends({}, params, {
          margin: "dense",
          error: !!error,
          readOnly: readOnly,
          disabled: false,
          helperText: error,
          label: title,
          required: required,
          fullWidth: true,
          variant: readOnly ? "filled" : "outlined",
          placeholder: placeholder,
          InputProps: _extends({}, params.InputProps, {
            endAdornment: React.createElement(
              React.Fragment,
              null,
              loading ? React.createElement(CircularProgress, { color: "inherit", size: 20 }) : null,
              params.InputProps.endAdornment
            )
          })
        }));
      }
    }),
    React.createElement(HintWarning, { text: hint })
  );
}

AsyncAutocomplete.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    getAsyncOptions: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    freeSolo: PropTypes.bool,
    getOptionLabel: PropTypes.func
  }),
  setValue: PropTypes.func,
  error: PropTypes.string
};

function AsyncAutocompleteFieldFormik(_ref) {
  var fieldData = _ref.fieldData,
      _ref$fieldData$path = _ref.fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 3),
      value = _useField2[0].value,
      error = _useField2[1].error,
      setValue = _useField2[2].setValue;

  return React.createElement(AsyncAutocomplete, {
    fieldData: fieldData,
    setValue: setValue,
    error: error,
    value: value
  });
}
AsyncAutocompleteFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired
  })
};

function RichTextEditorFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$placeH = _ref$fieldData.placeHolder,
      placeHolder = _ref$fieldData$placeH === undefined ? "..." : _ref$fieldData$placeH,
      _ref$fieldData$path = _ref$fieldData.path,
      path = _ref$fieldData$path === undefined ? "" : _ref$fieldData$path,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$requir = _ref$fieldData.required,
      required = _ref$fieldData$requir === undefined ? false : _ref$fieldData$requir;

  var _useField = useField(path),
      _useField2 = slicedToArray(_useField, 3),
      _useField2$0$value = _useField2[0].value,
      value = _useField2$0$value === undefined ? "" : _useField2$0$value,
      error = _useField2[1].error,
      setValue = _useField2[2].setValue;

  return React.createElement(
    "div",
    { className: classes.marginContainer },
    title && React.createElement(
      Typography,
      { variant: "body2",
        className: !!error ? classes.errorColor : "",
        color: "textSecondary" },
      required ? title + " *" : title,
      React.createElement(HintWarning, { text: warning, isWarning: true }),
      React.createElement(HintWarning, { text: hint })
    ),
    React.createElement(
      "div",
      { className: (error ? classes.editorRTEError : "") + " " + (readOnly ? classes.editorRTEReadOnly : "") },
      React.createElement(Editor, {
        theme: "snow",
        placeholder: placeHolder,
        value: value,
        onChange: function onChange(value) {
          return setValue(value);
        },
        readOnly: readOnly
        // classes={{

        // }}
        // className={readOnly ? classes.editorRTEReadOnly : classes.editorRTE}
      })
    ),
    !!error && React.createElement(
      FormHelperText,
      { error: true },
      error
    )
  );
}

RichTextEditorFormik.propTypes = {
  fieldData: PropTypes.shape({
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,
    placeHolder: PropTypes.string
  })
};

function GroupFieldFormik(_ref) {
  var _ref$fieldData = _ref.fieldData,
      _ref$fieldData$title = _ref$fieldData.title,
      title = _ref$fieldData$title === undefined ? "" : _ref$fieldData$title,
      _ref$fieldData$readOn = _ref$fieldData.readOnly,
      readOnly = _ref$fieldData$readOn === undefined ? false : _ref$fieldData$readOn,
      _ref$fieldData$hint = _ref$fieldData.hint,
      hint = _ref$fieldData$hint === undefined ? "" : _ref$fieldData$hint,
      _ref$fieldData$warnin = _ref$fieldData.warning,
      warning = _ref$fieldData$warnin === undefined ? "" : _ref$fieldData$warnin,
      _ref$fieldData$subfie = _ref$fieldData.subfields,
      subfields = _ref$fieldData$subfie === undefined ? [] : _ref$fieldData$subfie,
      FieldGenerator = _ref.FieldGenerator;


  return React.createElement(
    'div',
    { className: classes.borderContainer },
    title && React.createElement(
      Typography,
      { variant: 'body2',
        gutterBottom: true,
        color: 'textSecondary',
        component: 'div' },
      title,
      React.createElement(HintWarning, { text: warning, isWarning: true }),
      React.createElement(HintWarning, { text: hint })
    ),
    React.createElement(
      Grid,
      { container: true, spacing: 1 },
      subfields.map(function (subfieldData, i) {
        return React.createElement(
          Grid,
          { key: i, item: true,
            xs: 12, sm: subfieldData.col || 12 },
          React.createElement(FieldGenerator, { fieldData: subfieldData, readOnly: readOnly })
        );
      })
    )
  );
}

GroupFieldFormik.propTypes = {
  fieldData: PropTypes.shape({
    readOnly: PropTypes.bool,
    hint: PropTypes.string,
    warning: PropTypes.string,
    title: PropTypes.string,

    subfields: PropTypes.arrayOf(PropTypes.object)
  })
};

function FieldGenerator(_ref) {
  var fieldData = _ref.fieldData,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? true : _ref$readOnly;


  var fieldDataWithReadOnly = _extends({}, fieldData, { readOnly: fieldData.readOnly || readOnly });

  switch (fieldData.typeField) {
    case "group":
      return React.createElement(GroupFieldFormik, { fieldData: fieldDataWithReadOnly, FieldGenerator: FieldGenerator });
    case "text":
      return React.createElement(TextFieldFormik, { fieldData: fieldDataWithReadOnly });
    case "select":
      return React.createElement(SelectFieldFormik, { fieldData: fieldDataWithReadOnly });
    case "displayValue":
      return React.createElement(DisplayValueFormik, { fieldData: fieldDataWithReadOnly });
    case "date":
      return React.createElement(DateTimeFormik, { fieldData: fieldDataWithReadOnly });
    case "checkbox":
      return React.createElement(CheckboxFormik, { fieldData: fieldDataWithReadOnly });
    case "switch":
      return React.createElement(CheckboxFormik, { fieldData: fieldDataWithReadOnly, isSwitch: true });
    case "arrayObject":
      return React.createElement(ArrayOfObjectFieldFormik, { fieldData: fieldDataWithReadOnly, FieldGenerator: FieldGenerator });
    case "array":
      return React.createElement(ArrayFieldFormik, { fieldData: fieldDataWithReadOnly, FieldGenerator: FieldGenerator });
    case "autocomplete":
      return React.createElement(AutocompleteFieldFormik, { fieldData: fieldDataWithReadOnly });
    case "asyncAutocomplete":
      return React.createElement(AsyncAutocompleteFieldFormik, { fieldData: fieldDataWithReadOnly });
    case "richTextEditor":
      return React.createElement(RichTextEditorFormik, { fieldData: fieldDataWithReadOnly });
    default:
      return null;
  }
}

FieldGenerator.propTypes = {
  fieldData: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

function FormikWithRef(props, ref) {

  var _formikProps = void 0;
  useImperativeHandle(ref, function () {
    return _formikProps;
  });

  return React.createElement(
    Formik,
    props,
    function (formikProps) {
      _formikProps = formikProps;
      if (typeof props.children === 'function') {
        return props.children(formikProps);
      }
      return props.children;
    }
  );
}

var FormikWithRef$1 = forwardRef(FormikWithRef);

var lodash_isequal = createCommonjsModule(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

var defaultShouldTriggerErrors = function defaultShouldTriggerErrors(previousErrors, formik) {
  return !lodash_isequal(previousErrors, formik.errors);
};

function ErrorListener(_ref) {
  var onError = _ref.onError,
      shouldTriggerErrors = _ref.shouldTriggerErrors;


  shouldTriggerErrors = shouldTriggerErrors || defaultShouldTriggerErrors;

  var formik = useFormikContext();

  var _useState = useState(formik.errors),
      _useState2 = slicedToArray(_useState, 2),
      errors = _useState2[0],
      updateErrors = _useState2[1];

  useEffect(function () {
    if (shouldTriggerErrors(errors, formik)) {
      onError(formik.errors);
      updateErrors(errors);
    }
  }, [formik.errors]);

  return null;
}

function SubmitListener(_ref) {
  var onSubmitWithError = _ref.onSubmitWithError;


  var formik = useFormikContext();

  var _useState = useState(formik.isSubmitting),
      _useState2 = slicedToArray(_useState, 2),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  useEffect(function () {
    if (isSubmitting !== formik.isSubmitting) {
      if (!formik.isValid) {
        onSubmitWithError(formik);
      }
      setIsSubmitting(isSubmitting);
    }
  }, [formik.isSubmitting, formik.isValid]);

  return null;
}

function FormGenerator(_ref) {
  var _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === undefined ? {} : _ref$initialValues,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields,
      _ref$getFields = _ref.getFields,
      getFields = _ref$getFields === undefined ? null : _ref$getFields,
      _ref$onSubmit = _ref.onSubmit,
      _onSubmit = _ref$onSubmit === undefined ? function () {
    return null;
  } : _ref$onSubmit,
      _ref$onError = _ref.onError,
      onError = _ref$onError === undefined ? null : _ref$onError,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      _ref$formRef = _ref.formRef,
      formRef = _ref$formRef === undefined ? null : _ref$formRef,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === undefined ? true : _ref$validateOnBlur,
      _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === undefined ? true : _ref$validateOnChange,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === undefined ? true : _ref$validateOnMount,
      _ref$onSubmitWithErro = _ref.onSubmitWithError,
      onSubmitWithError = _ref$onSubmitWithErro === undefined ? null : _ref$onSubmitWithErro,
      _ref$validationSchema = _ref.validationSchema,
      validationSchema = _ref$validationSchema === undefined ? null : _ref$validationSchema,
      _ref$shouldTriggerErr = _ref.shouldTriggerErrors,
      shouldTriggerErrors = _ref$shouldTriggerErr === undefined ? null : _ref$shouldTriggerErr;

  return React.createElement(
    MuiPickersUtilsProvider,
    { utils: MomentUtils },
    React.createElement(
      FormikWithRef$1,
      {
        ref: formRef,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount,
        enableReinitialize: true,
        initialValues: initialValues,
        onSubmit: function onSubmit(values, _ref2) {
          var setSubmitting = _ref2.setSubmitting;

          _onSubmit(values);
          setSubmitting(false);
        },
        validationSchema: validationSchema
      },
      function (_ref3) {
        var values = _ref3.values,
            formFunction = objectWithoutProperties(_ref3, ['values']);
        return React.createElement(
          Form,
          null,
          !!onError && React.createElement(ErrorListener, { onError: onError, shouldTriggerErrors: shouldTriggerErrors }),
          !!onSubmitWithError && React.createElement(SubmitListener, { onSubmitWithError: onSubmitWithError }),
          (!!getFields ? getFields(values) : fields).map(function (field, i) {
            return React.createElement(
              'div',
              { key: i, className: classes.noCollapse },
              React.createElement(FieldGenerator, {
                readOnly: readOnly,
                formFunction: formFunction,
                fieldData: field
              })
            );
          })
        );
      }
    )
  );
}

FormGenerator.propTypes = {
  initialValues: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.object),
  getFields: PropTypes.func,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool,
  formRef: PropTypes.object.isRequired,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  validateOnMount: PropTypes.bool,
  validationSchema: PropTypes.object,
  onError: PropTypes.func,
  shouldTriggerErrors: PropTypes.func,
  onSubmitWithError: PropTypes.func
};

function FormDialogue(_ref) {
  var _ref$onOk = _ref.onOk,
      onOk = _ref$onOk === undefined ? function () {
    return null;
  } : _ref$onOk,
      _ref$disableCancelOnO = _ref.disableCancelOnOK,
      disableCancelOnOK = _ref$disableCancelOnO === undefined ? false : _ref$disableCancelOnO,
      _ref$okText = _ref.okText,
      okText = _ref$okText === undefined ? "Ok" : _ref$okText,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === undefined ? "sm" : _ref$maxWidth,
      _ref$open = _ref.open,
      open = _ref$open === undefined ? false : _ref$open,
      _ref$component = _ref.component,
      component = _ref$component === undefined ? null : _ref$component,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === undefined ? function () {
    return null;
  } : _ref$onCancel,
      _ref$link = _ref.link,
      link = _ref$link === undefined ? "" : _ref$link,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "" : _ref$text,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === undefined ? {} : _ref$initialValues,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      _ref$validationSchema = _ref.validationSchema,
      validationSchema = _ref$validationSchema === undefined ? null : _ref$validationSchema,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === undefined ? true : _ref$validateOnBlur,
      _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === undefined ? true : _ref$validateOnChange,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === undefined ? false : _ref$validateOnMount,
      _ref$onError = _ref.onError,
      onError = _ref$onError === undefined ? null : _ref$onError,
      _ref$shouldTriggerErr = _ref.shouldTriggerErrors,
      shouldTriggerErrors = _ref$shouldTriggerErr === undefined ? null : _ref$shouldTriggerErr,
      _ref$onSubmitWithErro = _ref.onSubmitWithError,
      onSubmitWithError = _ref$onSubmitWithErro === undefined ? null : _ref$onSubmitWithErro,
      _ref$getFields = _ref.getFields,
      getFields = _ref$getFields === undefined ? null : _ref$getFields;


  var formRef = useRef(null);

  return React.createElement(
    "div",
    null,
    React.createElement(
      Dialog,
      {
        fullWidth: true,
        maxWidth: maxWidth,
        open: open,
        onClose: onCancel,
        "aria-labelledby": "form-dialog-title"
      },
      React.createElement(
        DialogTitle,
        { id: "form-dialog-title" },
        title
      ),
      React.createElement(
        DialogContent,
        null,
        React.createElement(
          DialogContentText,
          null,
          text
        ),
        link && React.createElement(
          Button,
          { href: link.url, target: "_blank", color: "primary", size: "small", variant: "outlined" },
          link.name || link.url
        ),
        component,
        React.createElement(FormGenerator, {
          validationSchema: validationSchema,
          onSubmit: function onSubmit(values) {
            !disableCancelOnOK && onCancel();
            onOk(values);
          },
          fields: fields,
          getFields: getFields,
          formRef: formRef,
          readOnly: readOnly,
          initialValues: initialValues,
          validateOnBlur: validateOnBlur,
          validateOnChange: validateOnChange,
          validateOnMount: validateOnMount,
          onError: onError,
          shouldTriggerErrors: shouldTriggerErrors,
          onSubmitWithError: onSubmitWithError
        })
      ),
      React.createElement(
        DialogActions,
        null,
        React.createElement(
          Button,
          { onClick: onCancel, color: "primary" },
          "Cancel"
        ),
        React.createElement(
          Button,
          { onClick: function onClick() {
              return formRef.current && formRef.current.submitForm();
            }, color: "primary" },
          okText
        )
      )
    )
  );
}

FormDialogue.propTypes = {
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  disableCancelOnOK: PropTypes.bool,
  onError: PropTypes.func,
  okText: PropTypes.string,
  title: PropTypes.string,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  open: PropTypes.bool,
  component: PropTypes.object,
  link: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string.isRequired
  }),
  text: PropTypes.string,
  initialValues: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  validateOnMount: PropTypes.bool,
  validationSchema: PropTypes.object,
  shouldTriggerErrors: PropTypes.func,
  onSubmitWithError: PropTypes.func,
  getFields: PropTypes.func
};

// export { default } from "./components/FormGenerator";

export { FormGenerator, FieldGenerator, FormikWithRef$1 as FormikWithRef, AsyncAutocomplete, FormDialogue };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 174
// module chunks = 0